import React, { useContext, useEffect, useRef, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import GenerateSalary from "./GenerateSalaryList";
import ListProcessTable from "./ListProcessTable";
import GenerateSalaryEdit from "./GenerateSalaryEdit";
import GenerateSalaryView from "./GenerateSalaryView";
import dayjs from "dayjs";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import Select from "react-select";
import OButton from "components/reusable/OButton";
import Pagination from "pages/Pagination";
import classNames from "classnames";
import helpers from "utils/helpers";
import CustomSelect from "components/reusable/CustomSelect";
import { durationOptions, salaryOptions } from "utils/constants";
import { FiDownload } from "react-icons/fi";
import { exportSalaryToExcel } from "./salaryExport";

const ProcessSalaryManager = () => {
  const { t } = useTranslation();
  const { updatePageName } = useContext(AuthContext);

  const [generateList, setGenerateList] = useState([]);
  const [processList, setProcessList] = useState([]);

  const [generateSalaryEdit, setGenerateSalaryEdit] = useState(false);
  const [generateSalaryView, setGenerateSalaryView] = useState(false);
  const [currentItem, setCurrentItem] = useState("");
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [duration, setDuration] = useState("");
  const [startDates, setStartDates] = useState("");
  const [endDates, setEndDates] = useState("");
  const [processToggle, setProcessToggle] = useState("generate-tab");
  const [filterData, setFilterData] = useState({
    department: [],
    searchKey: "",
    startsDate: "",
    endsDate: "",
    isReset: false,
    isFilter: false,
  });
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
    totalItems: 0,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  const [searchTermList, setSearchTermList] = useState("");
  const [debouncedSearchTermList, setDebouncedSearchTermList] = useState("");
  const [isInitializedList, setIsInitializedList] = useState(false);
  const [processfilterData, setProcessFilterData] = useState({
    status: "",
    duration: "",
    searchKeys: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const requestId = useRef(0);

  const buildListPayload = (extra = {}) => {
    const { status, startDate, endDate, searchKeys, duration: listDuration } = processfilterData;
    return {
      page,
      pageSize,
      status,
      duration: listDuration,
      startDate: helpers?.ternaryCondition(startDate, dayjs(startDate).format("YYYY-MM-DD"), null),
      endDate: helpers?.ternaryCondition(endDate, dayjs(endDate).format("YYYY-MM-DD"), null),
      keyword: searchKeys?.trim(),
      sortBy: sort.sortBy,
      sortType: sort.sortType,
      ...extra,
    };
  };

  const allGenerateSalary = async () => {
    const currentTab = processToggle;
    const id = ++requestId.current;
    try {
      if (currentTab === "generate-tab") {
        const { department, searchKey, startsDate, endsDate } = filterData;
        const departmentIds = (department || []).map((depart) => depart?.value);

        const payload = {
          keyword: searchKey,
          startDate: helpers?.ternaryCondition(startsDate, dayjs(startsDate).format("YYYY-MM-DD"), null),
          endDate: helpers?.ternaryCondition(endsDate, dayjs(endsDate).format("YYYY-MM-DD"), null),
        };
        
        // FIX: If departmentIds is empty, backend now returns all employees
        if (departmentIds.length > 0) {
          payload.departmentID = JSON.stringify(departmentIds);
        }

        const result = await apiGet(apiPath?.listDepartment, payload);
        if (id !== requestId.current) return;
        setGenerateList(result?.data?.results?.docs || []);
      } else {
        const result = await apiGet(apiPath?.generateSalaryList, buildListPayload());
        if (id !== requestId.current) return;
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setProcessList(response?.docs || []);
        setPaginationObj({
          page: helpers?.ternaryCondition(resultStatus, response?.page, 1),
          pageCount: helpers?.ternaryCondition(resultStatus, response?.totalPages, 1),
          perPageItem: helpers?.ternaryCondition(resultStatus, response?.docs?.length, 0),
          totalItems: helpers?.ternaryCondition(resultStatus, response?.totalDocs, 0),
        });
      }
    } catch (error) {
      if (id !== requestId.current) return;
      if (currentTab === "generate-tab") setGenerateList([]);
      else setProcessList([]);
      console.log("error in get salary list==>>>>", error.message);
    }
  };

  const fetchAllSalaryRecordsForExport = async () => {
    try {
      const all = [];
      let currentPage = 1;
      let totalPages = 1;
      do {
        const result = await apiGet(apiPath?.generateSalaryList, buildListPayload({ page: currentPage, pageSize: 100 }));
        const response = result?.data?.results;
        all.push(...(response?.docs || []));
        totalPages = response?.totalPages || 1;
        currentPage += 1;
      } while (currentPage <= totalPages);
      return all;
    } catch (error) {
      console.log("error fetching all records for export:", error);
      return [];
    }
  };

  const handleExport = async () => {
    try {
      const allRecords = await fetchAllSalaryRecordsForExport();
      if (allRecords.length === 0) {
        console.warn("No data to export");
        return;
      }
      exportSalaryToExcel(allRecords, 1, t);
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  const tabBtnClass = "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
  const tabActiveClass = "border-blue-600 text-blue-600";
  const tabBorderNoneClass = "border-transparent";

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };

  const switchTab = (tab) => {
    if (tab === processToggle) return;
    requestId.current += 1;
    setProcessToggle(tab);
    setPage(1);
  };

  const handleEdit = (item) => {
    setCurrentItem(item);
    setGenerateSalaryEdit(!generateSalaryEdit);
  };

  const handleView = (item) => {
    setCurrentItem(item);
    setGenerateSalaryView(!generateSalaryView);
  };

  // FIX: On load, fetch all data. Only fetch if department changes.
  useEffect(() => {
    if (processToggle !== "generate-tab") return;
    allGenerateSalary();
  }, [processToggle, filterData, selectedDepartment]);

  useEffect(() => {
    if (processToggle === "list-tab") {
      allGenerateSalary();
    }
  }, [processToggle, processfilterData, sort, page]);

  useEffect(() => {
    updatePageName("Process Salary");
  }, []);

  const departmentList = async () => {
    try {
      const res = await apiGet(apiPath.getDepartmentList, {});
      const data = res?.data?.results;
      const newArray = (data || []).map((item) => ({
        label: item?.name,
        value: item?._id,
      }));
      setDepartments(newArray);
    } catch (error) {
      console.log("error in get all department list==>>>>", error.message);
    }
  };

  useEffect(() => {
    departmentList();
  }, []);

  const handleSearchKey = (e) => {
    setDuration(e.target.value);
    setStartDates("");
    setEndDates("");
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true });
  };

  const handleSelectDepartment = (item) => {
    setDuration("");
    setStartDates("");
    setEndDates("");
    setFilterData({ ...filterData, department: item || [], searchKey: "", isFilter: true });
  };

  const handleDateChange = (start, end) => {
    setStartDates(start);
    setEndDates(end);
  };

  const handleReset = () => {
    setProcessFilterData({
      status: "",
      duration: "",
      searchKeys: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setSearchTermList("");
  };

  const handleResetProcess = () => {
    setFilterData({
      searchKey: "",
      startsDate: "",
      endsDate: "",
      isReset: true,
      isFilter: false,
      department: [],
    });
    setSelectedDepartment([]);
    setDuration("");
    setStartDates("");
    setEndDates("");
    setPage(1);
    setSearchTerm("");
  };

  const handleProcessDateChange = (start, end) => {
    setPage(1);
    setProcessFilterData({
      ...processfilterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };

  const statusPage = (e) => {
    setProcessFilterData({
      ...processfilterData,
      status: e.target.value,
      isFilter: true,
    });
    setPage(1);
  };

  const statusPageDuration = (e) => {
    setProcessFilterData({
      ...processfilterData,
      duration: e.target.value,
      isFilter: true,
    });
    setPage(1);
  };

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage,
    });
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  useEffect(() => {
    if (!isInitializedList) {
      setIsInitializedList(true);
    } else if (searchTermList || !processfilterData?.isReset) {
      setProcessFilterData({
        ...processfilterData,
        isReset: false,
        searchKeys: helpers?.ternaryCondition(debouncedSearchTermList, debouncedSearchTermList, ""),
        isFilter: helpers?.ternaryCondition(debouncedSearchTermList, true, false),
      });
      setPage(1);
    }
  }, [debouncedSearchTermList]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTermList(searchTermList);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTermList]);

  // FIX: UI progressive disable and guidance
  const isDurationDisabled = selectedDepartment.length === 0;
  const isDateDisabled = !filterData.searchKey;

  let paginationComponent = null;

  if (paginationObj?.totalItems > 0) {
    paginationComponent = <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} />;
  }

  return (
    <>
      <div className="py-3 my-2">
        <ul className="border-b flex">
          <li className="mr-0 xl:mr-5">
            <button
              onClick={() => switchTab("generate-tab")}
              className={classNames(tabBtnClass, {
                [tabActiveClass]: processToggle === "generate-tab",
                [tabBorderNoneClass]: processToggle !== "generate-tab",
              })}
            >
              Generate Salary
            </button>
          </li>
          <li className="mx-0 xl:mx-5">
            <button
              onClick={() => switchTab("list-tab")}
              className={classNames(tabBtnClass, {
                [tabActiveClass]: processToggle === "list-tab",
                [tabBorderNoneClass]: processToggle !== "list-tab",
              })}
            >
              List Process Tab
            </button>
          </li>
        </ul>
      </div>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            {processToggle === "generate-tab" ? (
              <>
                <div className=" ">
                  <div className=" py-4">
                    <div className="bg-white  ">
                      <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
                        <div className="col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0">
                          <div className="flex items-center lg:pt-0 pt-3 flex-wrap ">
                            <div className="flex items-center mb-3">
                              <Select
                                isMulti
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    padding: "0px 4px",
                                    borderRadius: "0.5rem",
                                    border: "2px solid rgb(223 223 223);",
                                    color: "#000",
                                  }),
                                }}
                                name="departmentId"
                                options={departments}
                                placeholder={
                                  <>
                                    <span style={{ fontSize: "0.875rem" }} className="text-[#A5A5A5]">
                                      {" "}
                                      {t("SELECT_DEPARTMENT")}
                                    </span>
                                    <span className="text-red-500 ">*</span>
                                  </>
                                }
                                className="basic-multi-select"
                                classNamePrefix="select"
                                value={selectedDepartment}
                                onChange={(item) => {
                                  setSelectedDepartment(item || []);
                                  handleSelectDepartment(item);
                                }}
                              />
                            </div>
                            <div className="flex items-center  ml-3 mb-3">
                              <select
                                id=""
                                type="text"
                                name="duration"
                                className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer disabled:opacity-50"
                                placeholder=" "
                                value={filterData?.searchKey}
                                onChange={(e) => handleSearchKey(e)}
                                disabled={isDurationDisabled} // Disables if no department
                              >
                                <option key="" value="">{t("SELECT_DURATION")}</option>
                                <option key="weekly" value="Weekly">{t("WEEKLY")}</option>
                                <option key="fortninght" value="Fortnight">{t("FORTNIGHT")}</option>
                                <option key="monthly" value="Monthly">{t("MONTHLY")}</option>
                              </select>
                            </div>
                            <ODateRangePicker 
                              handleDateChange={handleDateChange} 
                              isDate={true} 
                              duration={duration} 
                              isReset={filterData?.isReset} 
                              setIsReset={setFilterData} 
                              // Ideally ODateRangePicker accepts a disabled prop. If not, user will be blocked by message below.
                            />
                            <OButton label="Reset" type="button" onClick={handleResetProcess} extraClasses="ml-3 mb-3" style={{ borderRadius: "0.5rem" }} />
                          </div>
                          
                          {/* UI Guidance Message */}
                          <div className="w-full text-xs text-blue-500 mt-2">
                            {selectedDepartment.length === 0 && !filterData.searchKey && "Please select a department to proceed."}
                            {selectedDepartment.length > 0 && !filterData.searchKey && "Please select a duration to proceed."}
                            {selectedDepartment.length > 0 && filterData.searchKey && !startDates && "Please select a date range to view employees and generate salary."}
                          </div>

                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <GenerateSalary
                  generateList={generateList}
                  setGenerateList={setGenerateList}
                  allGenerateSalary={allGenerateSalary}
                  selectedDepartment={selectedDepartment}
                  startDate={startDates}
                  endDate={endDates}
                  duration={duration}
                />
              </>
            ) : (
              <>
                <div className="flex justify-between items-center px-4 py-2 border-b border-b-[#E3E3E3]">
                  <div className="flex-1">
                    <form className="flex gap-2">
                      <div className="col-span-2 flex flex-wrap items-center">
                        <div className="flex items-center flex-wrap">
                          <div className="relative flex items-center mb-3">
                            <input
                              type="search"
                              id="default-search"
                              className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              placeholder={t("SEARCH_BY_EMPLOYEE_NAME")}
                              value={searchTermList}
                              title=""
                              required
                              onChange={(e) => setSearchTermList(e.target.value)}
                            />
                          </div>
                          <ODateRangePicker handleDateChange={handleProcessDateChange} isReset={processfilterData?.isReset} setIsReset={setProcessFilterData} />
                          <CustomSelect id="status" name="status" value={processfilterData?.status} onChange={statusPage} options={salaryOptions} placeholder="O_ALL" t={t} />
                          <CustomSelect id="duration" name="duration" value={processfilterData?.duration} onChange={statusPageDuration} options={durationOptions} placeholder="O_ALL" t={t} />
                          <OButton label="Reset" type="button" onClick={handleReset} extraClasses="ml-3 mb-3" style={{ borderRadius: "0.5rem" }} />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="flex items-center">
                    <button
                      onClick={handleExport}
                      className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors duration-200 text-sm font-medium"
                      disabled={processList.length === 0}
                    >
                      <FiDownload className="w-4 h-4" />
                      {t("EXPORT")}
                    </button>
                  </div>
                </div>
                <ListProcessTable
                  generateList={processList}
                  allGenerateSalary={allGenerateSalary}
                  handleEdit={handleEdit}
                  handleView={handleView}
                  setSort={setSort}
                  sort={sort}
                  page={page}
                />
                {paginationComponent}
              </>
            )}
            {generateSalaryEdit && <GenerateSalaryEdit allGenerateSalary={allGenerateSalary} handleEdit={handleEdit} currentItem={currentItem} />}
            {generateSalaryView && <GenerateSalaryView allGenerateSalary={allGenerateSalary} handleView={handleView} currentItem={currentItem} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcessSalaryManager;